import { Theme } from '@mui/material/styles'
//
import Accordion from './Accordion'
import Alert from './Alert'
import Autocomplete from './Autocomplete'
import Avatar from './Avatar'
import Backdrop from './Backdrop'
import Badge from './Badge'
import Button from './Button'
import ButtonGroup from './ButtonGroup'
import Card from './Card'
import Checkbox from './Checkbox'
import Chip from './Chip'
import ControlLabel from './ControlLabel'
import CssBaseline from './CssBaseline'
import DataGrid from './DataGrid'
import DatePicker from './DatePicker'
import Dialog from './Dialog'
import Divider from './Divider'
import Drawer from './Drawer'
import Fab from './Fab'
import IconButton from './IconButton'
import Input from './Input'
import Link from './Link'
import Lists from './List'
import LoadingButton from './LoadingButton'
import Menu from './Menu'
import Pagination from './Pagination'
import Paper from './Paper'
import Popover from './Popover'
import Progress from './Progress'
import Radio from './Radio'
import Rating from './Rating'
import Select from './Select'
import Skeleton from './Skeleton'
import Slider from './Slider'
import StepConnector from './StepConnector'
import StepLabel from './StepLabel'
import Stepper from './Stepper'
import SvgIcon from './SvgIcon'
import Switch from './Switch'
import Table from './Table'
import Tabs from './Tabs'
import Timeline from './Timeline'
import ToggleButton from './ToggleButton'
import Tooltip from './Tooltip'
import TreeView from './TreeView'
import Typography from './Typography'

// ----------------------------------------------------------------------
// No `MuiBreadcrumbs` here, and that is the point.
//
// There was one, spacing a separator this console never draws: the only trail
// in the app is hand-built in `layouts/main/Topbar.tsx`, out of a Link, an
// `Iconify` chevron and a Typography, and no screen renders MUI's component at
// all. So the rule shipped, read as the trail's spacing, and moved nothing —
// a style someone would go on believing they had already fixed. An override
// for a component the app does not mount is dead weight that lies.
//
// If a screen ever does want MUI's Breadcrumbs, the separator's spacing is the
// theme's job again and this is where it goes back.
// ----------------------------------------------------------------------

/**
 * A Stack spaces with `gap`, not with a margin on every child but the first.
 *
 * MUI's default is `margin-left` (or `margin-top`) on `& > :not(style) ~
 * :not(style)`, and a flex line has no idea it is the second one — so a Stack
 * that wraps carries the margin onto the start of every wrapped line. On
 * /admin/charging the "During rentals" tile began 16px right of "Total
 * energy", which is the column gap exactly, and no amount of looking at that
 * screen explained it.
 *
 * `useFlexGap` is identical for a Stack that does not wrap and correct for
 * one that does, so it is a default here rather than a prop on the handful of
 * rows someone noticed. The one thing it changes beyond the gap: MUI's
 * margin-based mode also resets `margin: 0` on every child, and `gap` does
 * not — a child that carries a margin of its own now keeps it.
 */
const Stack = () => ({
  MuiStack: {
    defaultProps: { useFlexGap: true },
  },
})

export default function ComponentsOverrides(theme: Theme) {
  return Object.assign(
    Fab(theme),
    Tabs(theme),
    Chip(theme),
    Card(theme),
    Menu(theme),
    Link(theme),
    Input(theme),
    Radio(theme),
    Badge(theme),
    Lists(theme),
    Table(theme),
    Paper(theme),
    Alert(theme),
    Switch(theme),
    Select(theme),
    Button(theme),
    IconButton(theme),
    Rating(theme),
    DatePicker(theme),
    Dialog(theme),
    Divider(theme),
    Avatar(theme),
    Slider(theme),
    Drawer(theme),
    Stepper(theme),
    StepConnector(theme),
    StepLabel(theme),
    Tooltip(theme),
    Popover(theme),
    SvgIcon(theme),
    Checkbox(theme),
    DataGrid(theme),
    Skeleton(theme),
    Timeline(theme),
    TreeView(theme),
    Backdrop(theme),
    Progress(theme),
    Accordion(theme),
    Typography(theme),
    Pagination(theme),
    ButtonGroup(theme),
    CssBaseline(theme),
    Autocomplete(theme),
    ControlLabel(theme),
    ToggleButton(theme),
    LoadingButton(theme),
    Stack(),
  )
}
